<img class="image" [src]="getSanitizedUrl(image.url)">
<div class="actions">
    <a [href]="getSanitizedUrl(image.url)" [download]="image.name">{{'admin.strain.measurements.images.download' | translate}}</a>
    <a href="#" id="reset" (click)="changeImage($event)">{{'admin.strain.measurements.images.replace' | translate}}</a>
</div>
